/* eslint-disable absolutely-import/import */

import './index.css';

import { ThemeProvider } from '@mui/material/styles';
import process from 'process';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { WalletProvider } from '~context/WalletContext';
import Monitoring from '~utils/monitoring';
import App from '~views/App';

import store from './features';
import reportWebVitals from './reportWebVitals';
import theme from './theme';

window.global = window;
window.process = process;

Monitoring.init();

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <WalletProvider>
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </Provider>
      </WalletProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
